import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown, Menu, Modal } from '@storable/canaveral-components';
import AlertBanner from './AlertBanner';
import styles from './styles.scss';


const propTypes = {
  actions: PropTypes.arrayOf([
    PropTypes.shapeOf({
      name: PropTypes.string,
      text: PropTypes.string,
      context: PropTypes.string,
      confirmationModal: PropTypes.shapeOf({
        title: PropTypes.string,
        text: PropTypes.string,
        accept: PropTypes.string,
        decline: PropTypes.string,
      }),
      handler: PropTypes.func.isRequired,
      handlerResult: PropTypes.shapeOf({
        data: PropTypes.object,
        errors: PropTypes.array,
        loading: PropTypes.bool,
      }).isRequired,
    }),
  ]).isRequired,
  setAlert: PropTypes.func.isRequired,
  alertBanner: PropTypes.shapeOf({
    context: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
  }),
};

const defaultProps = {
  alertBanner: undefined,
};

const mapContextToStyle = (context) => {
  const map = {
    error: 'actionContextError',
  };
  return map[context];
};

const defaultActionData = {
  accept: 'Proceed',
  decline: 'Cancel',
};

const SettingsActions = ({ actions, setAlert, alertBanner }) => {
  useEffect(() => (alertBanner
    ? setAlert(<AlertBanner
        context={alertBanner.context}
        icon={alertBanner.icon}
        text={alertBanner.text}
    />)
    : setAlert()),
  [alertBanner]);
  const [modalData, setModalData] = useState({});
  const [currentActionIndex, setCurrentActionIndex] = useState();
  const loading = actions[currentActionIndex]?.loading;

  const handleAction = async (action, index) => {
    setCurrentActionIndex(index);
    if (!action.confirmationModal) {
      await action.handler();
      return setCurrentActionIndex();
    }

    return setModalData({
      ...defaultActionData,
      ...action.confirmationModal,
      acceptHandler: async () => {
        await action.handler();
        setModalData({});
        setCurrentActionIndex();
      },
      showModal: true,
      declineHandler: () => {
        setModalData({});
        setCurrentActionIndex();
      },
    });
  };

  return (
    <>
      <Modal
        onDismiss={() => setModalData({})}
        show={modalData.showModal}
        size="sm"
        className={styles.actionsModal}
      >
        <Modal.Header>
          <Modal.Title id="actions-modal-title">{modalData.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalData.text}
        </Modal.Body>
        <Modal.Footer>
          <Button
            context="neutral"
            onClick={modalData.declineHandler}
            disabled={loading}
          >
            {modalData.decline}
          </Button>
          <Button
            context="danger"
            onClick={modalData.acceptHandler}
            disabled={loading}
          >
            {modalData.accept}
          </Button>
        </Modal.Footer>
      </Modal>
      <Dropdown
        className={styles.dropdownButton}
        toggle={(
          <Dropdown.Toggle>
            Actions
          </Dropdown.Toggle>
        )}
      >
        <Menu>
          {actions.map((action, index) => (
            <Menu.Item
              key={action.text}
              className={styles[mapContextToStyle(action.context)]}
              onClick={() => handleAction(action, index)}
              type="button"
            >
              {action.text}
            </Menu.Item>
          ))}
        </Menu>
      </Dropdown>
    </>
  );
};

SettingsActions.propTypes = propTypes;
SettingsActions.defaultProps = defaultProps;

export default SettingsActions;
